module.exports = __webpack_public_path__ + "img/icon_deposit.12f50a6.webp";